import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {TranslateService} from "@ngx-translate/core";
import {DropdownModule} from 'primeng/dropdown';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  allusers: any[] = [];
  transStatus: any[] = [{'value':'','label':''},{'value':'0','label':'New'},{'value':1,'label':'Under Process'},{'value':2,'label':'Done'},{'value':3,'label':'Decline'},{'value':9,'label':'Not a Process'}];
  havepermission = false;
  private userRoles: any[] = [];
  private _undoButton: any;
  @Input() creation_user;
  @Input() last_update_user;
  @Input() on_behalf;
  @Input() last_on_behalf;
  @Input() trans_status;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private userService: UserService,
              public translate: TranslateService,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    let filter = JSON.parse(localStorage.getItem('filter'));
    filter = {};
    localStorage.setItem('filter', JSON.stringify(filter));

    this.userService.getAllUsers().subscribe(
      allusers => {
        this.allusers = allusers.userslist;
      });

    this.form = this.formBuilder.group({
      on_behalf: new FormControl(''),
      trans_status: new FormControl(''),
      creation_user: new FormControl(''),
      last_on_behalf: new FormControl(''),
      last_update_user: new FormControl(''),
    });

    if(localStorage.getItem('currentUser')) {
      const userdata = JSON.parse(localStorage.getItem('currentUser'));
      this.userRoles = userdata.roles.description;
      let urltxt = this.router.routerState.snapshot.url.replace(/^\//, '');
      let urlparts = urltxt.split('/');
      console.log(urlparts[0]);
      let namescr = urlparts[0];
      if(namescr == "itemsGroups"){
        namescr = "items_groups";
      }
      if(this.userRoles.indexOf(localStorage.getItem('OpenSystem') +'.'+namescr+'.showallrec') !== -1) {
        this.havepermission = true;
      }
      if(this.userRoles.indexOf('setting' +'.'+namescr+'.showallrec') !== -1) {
        this.havepermission = true;
      }

    }
  }
  ngAfterViewInit() {
    this._undoButton = document.getElementById('undoButton');
    if (this._undoButton) {
      this._undoButton.onclick = ((e: any) => {
        console.log('search button');
        this.form.reset();
      });
    }
  }

  reset() {
    this.creation_user = '';
    this.last_on_behalf = '';
    this.on_behalf = '';
    this.last_update_user = '';
    this.trans_status = '';
  }


  selectchangeuser(args ,fieldname:string='') {
    let filter = JSON.parse(localStorage.getItem('filter'));
    if(!filter) {filter = {};}
    filter[fieldname] = args.value;
    localStorage.setItem('filter', JSON.stringify(filter));
  }
}


// WEBPACK FOOTER //
// ./src/app/components/search/search.component.ts